var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.75 0.638672H9.25C9.66562 0.638672 10 0.973047 10 1.38867V6.63867H12.7406C13.2969 6.63867 13.575 7.31055 13.1812 7.7043L8.42813 12.4605C8.19375 12.6949 7.80937 12.6949 7.575 12.4605L2.81562 7.7043C2.42188 7.31055 2.7 6.63867 3.25625 6.63867H6V1.38867C6 0.973047 6.33437 0.638672 6.75 0.638672ZM16 12.3887V15.8887C16 16.3043 15.6656 16.6387 15.25 16.6387H0.75C0.334375 16.6387 0 16.3043 0 15.8887V12.3887C0 11.973 0.334375 11.6387 0.75 11.6387H5.33437L6.86562 13.1699C7.49375 13.798 8.50625 13.798 9.13437 13.1699L10.6656 11.6387H15.25C15.6656 11.6387 16 11.973 16 12.3887ZM12.125 15.1387C12.125 14.7949 11.8438 14.5137 11.5 14.5137C11.1562 14.5137 10.875 14.7949 10.875 15.1387C10.875 15.4824 11.1562 15.7637 11.5 15.7637C11.8438 15.7637 12.125 15.4824 12.125 15.1387ZM14.125 15.1387C14.125 14.7949 13.8438 14.5137 13.5 14.5137C13.1562 14.5137 12.875 14.7949 12.875 15.1387C12.875 15.4824 13.1562 15.7637 13.5 15.7637C13.8438 15.7637 14.125 15.4824 14.125 15.1387Z",
    fill: "#524E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.ca0048e62f74a87a459d4dbd7ed6b579.svg";
export { ForwardRef as ReactComponent };